import classNames from 'classnames';

const Salmon = ({ className = '' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('', className)}
    role="presentation"
    pointerEvents="none"
  >
    <title>Salmon</title>
    <path
      opacity="0.4"
      d="M6.34375 5.92844V8.42866C7.95254 8.4254 9.49438 7.78442 10.6314 6.64623C11.7684 5.50804 12.4077 3.96549 12.4093 2.35669H9.90904C9.9081 3.30257 9.5324 4.20954 8.86416 4.87899C8.19592 5.54843 7.28963 5.92579 6.34375 5.92844V5.92844Z"
      fill="#008600"
    />
    <path
      opacity="0.4"
      d="M15.6204 2.47911C15.3552 2.39932 15.0798 2.35841 14.8029 2.35767H13.1241C13.1221 4.15577 12.4073 5.87971 11.1363 7.15162C9.86527 8.42352 8.14185 9.13961 6.34375 9.14291V11.6431C8.78331 11.6388 11.1233 10.6754 12.8589 8.96098C14.5944 7.24652 15.5863 4.91843 15.6204 2.47911Z"
      fill="#008600"
    />
    <path
      opacity="0.4"
      d="M16.3268 2.7998C16.2102 5.37066 15.108 7.79788 13.2491 9.57756C11.3902 11.3572 8.91725 12.3527 6.34375 12.3573V14.8575C8.55323 14.854 10.7223 14.2649 12.63 13.1501C14.5376 12.0353 16.1156 10.4347 17.2031 8.51139C17.4222 7.446 17.5736 6.36779 17.6562 5.28324C17.6708 4.78925 17.5557 4.30007 17.3225 3.86436C17.0892 3.42866 16.746 3.06163 16.3268 2.7998V2.7998Z"
      fill="#008600"
    />
    <path
      opacity="0.4"
      d="M16.7052 10.5288C15.4724 12.0988 13.8993 13.3685 12.1045 14.2422C10.3097 15.1158 8.33992 15.5705 6.34375 15.5721V18.0723C9.63313 18.0738 12.8389 17.0363 15.5037 15.1078C15.846 13.3491 16.2964 11.9932 16.7052 10.5288Z"
      fill="#008600"
    />
    <path
      opacity="0.4"
      d="M13.2029 21.6428C13.6528 21.6411 14.0854 21.4697 14.4143 21.1628C14.7433 20.856 14.9443 20.4363 14.9772 19.9877C13.4173 20.7569 11.7614 21.3136 10.0537 21.643L13.2029 21.6428Z"
      fill="#008600"
    />
    <path
      opacity="0.4"
      d="M6.34375 4.85777V5.21494C7.10031 5.21263 7.82513 4.91064 8.35953 4.3751C8.89393 3.83957 9.19434 3.11411 9.19504 2.35754H8.84358C8.18054 2.35764 7.54469 2.6211 7.07589 3.08997C6.60708 3.55884 6.34375 4.19473 6.34375 4.85777V4.85777Z"
      fill="#008600"
    />
    <path
      opacity="0.4"
      d="M15.3298 16.0953C12.6621 17.8526 9.53724 18.7881 6.34277 18.7858V19.8573C6.34346 20.1285 6.40626 20.396 6.52637 20.6392C6.64649 20.8824 6.82074 21.0949 7.03572 21.2603C9.81774 21.1624 12.5433 20.4481 15.0157 19.1688C15.081 18.0009 15.1911 16.9935 15.3298 16.0953Z"
      fill="#008600"
    />
    <path
      d="M8.12742 22C7.55905 22 7.01395 21.7742 6.61205 21.3723C6.21015 20.9704 5.98438 20.4253 5.98438 19.857V4.8574C5.98518 4.09982 6.28647 3.37349 6.82216 2.8378C7.35785 2.30211 8.08419 2.0008 8.84177 2H14.8013C15.2474 2.00051 15.6887 2.09339 16.0972 2.27279C16.5058 2.4522 16.8727 2.71423 17.175 3.04241C17.4731 3.36683 17.7008 3.74943 17.8437 4.16613C17.9867 4.58284 18.0419 5.02463 18.0058 5.4637C17.7779 8.16126 17.2525 9.95928 16.7446 11.6982C16.126 13.8161 15.4863 16.0061 15.3427 19.9239C15.3257 20.4804 15.0925 21.0083 14.6927 21.3958C14.293 21.7832 13.758 21.9997 13.2012 21.9993H8.12707L8.12742 22ZM8.84177 2.71506C8.27356 2.71558 7.72879 2.94153 7.32701 3.34332C6.92522 3.74511 6.69924 4.2899 6.69872 4.85811V19.8577C6.69872 20.2366 6.84927 20.6 7.1172 20.8679C7.38513 21.1358 7.74851 21.2864 8.12742 21.2864H13.2016C13.5732 21.2862 13.9301 21.1413 14.1966 20.8823C14.4631 20.6233 14.6183 20.2707 14.6291 19.8993C14.7759 15.8925 15.4283 13.6591 16.0594 11.4992C16.5803 9.71569 17.0723 8.03125 17.2943 5.40513C17.3243 5.0644 17.2824 4.72118 17.1712 4.39769C17.0601 4.0742 16.8823 3.77766 16.6493 3.52728C16.414 3.27179 16.1284 3.06779 15.8104 2.92813C15.4924 2.78847 15.1489 2.71617 14.8016 2.71578L8.84177 2.71506Z"
      className="fill-green-130"
    />
  </svg>
);

Salmon.propTypes = {
  className: PropTypes.string,
};

export default Salmon;
